import { connect } from "react-redux";
import React from "react";

import * as actions from "../actions/actions";
import { browserHistory } from "react-router";
import StickyNav from "./sticky-nav";
let CreatorInfo = require("./moderation-batch-creator-info");
let IconModerationMenu = require("./moderation-icon-menu");
let Loading = require("./loading");
let ModerationIconCards = require("./moderation-icon-cards");

class ModerationUnderReview extends React.Component {
    renderActionMenus(iconsSelected) {
        if (iconsSelected > 0) {
            return (
                <StickyNav>
                    <IconModerationMenu
                        upload={this.props.upload}
                        icons={this.props.icons}
                        iconsSelected={iconsSelected}
                    />
                </StickyNav>
            );
        } else {
            return (
                <StickyNav>
                    <CreatorInfo
                        upload={this.props.upload}
                        icons={this.props.icons}
                    />
                </StickyNav>
            );
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.upload) {
            if (this.props.upload.icon_count === 0) {
                if (this.completedUpload !== this.props.upload.id) {
                    this.completedUpload = this.props.upload.id;
                    this.props.completeUpload(this.props.upload.id);
                    browserHistory.push("/fort/modparty/creators/");
                    // this.props.showModal(null, "RATE_CREATOR", {
                    //     upload: this.props.upload
                    // });
                }
            }
        }
    }

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.fetchUploadIcons("");
    }

    continueReviewing() {
        this.props.fetchContinueUploadIcons("");
    }

    render() {
        if (this.props.upload) {
            if (this.props.upload.error) {
                return (
                    <div className="no-results" style={{ color: "gray" }}>
                        There are no active uploads to review at the moment.
                        <div>
                            <button
                                type="button"
                                className="btn btn-default blue"
                                style={{
                                    marginTop: "40px",
                                    padding: "10px 40px"
                                }}
                                onClick={this.continueReviewing.bind(this)}
                            >
                                Continue Reviewing...
                            </button>
                        </div>
                    </div>
                );
            }

            let actionMenu = this.renderActionMenus(this.props.iconsSelected);

            return (
                <div>
                    {actionMenu}
                    <ModerationIconCards
                        upload={this.props.upload}
                        icons={this.props.icons}
                    />
                </div>
            );
        } else {
            return <Loading />;
        }
    }
}

function mapStateToProps(state, ownProps) {
    let icons = [],
        iconsSelected = 0,
        upload = undefined,
        totalIconsLeft;


    if (state.uploads.keys) {
        state.uploads.keys.forEach(uploadId => {
            if (state.uploads[uploadId].status === "active") {
                upload = state.uploads[uploadId];

                upload.pagination = {
                    icons: state.pagination.uploadIcons[""]
                };

                upload.result = state.uploads[uploadId].result;

                totalIconsLeft = upload.icon_count;

                if (upload.icons) {
                    upload.iconKeys.forEach(iconId => {
                        let i = JSON.parse(
                            JSON.stringify(upload.icons[iconId])
                        );

                        if (i.selected) {
                            if (!i.status) {
                                iconsSelected = iconsSelected + 1;
                            }
                        }

                        if (!i.status) {
                            totalIconsLeft = totalIconsLeft - 1;
                            icons.push(i);
                        }
                    });
                }
            }
        });
    }

    if (state.uploads.error) upload = state.uploads;

    return { icons, upload, iconsSelected, totalIconsLeft };
}

module.exports = connect(mapStateToProps, {
    completeUpload: actions.completeUpload,
    fetchContinueUploadIcons: actions.fetchContinueUploadIcons,
    fetchUploadIcons: actions.fetchUploadIcons,
    showModal: actions.showModal
})(ModerationUnderReview);
